<template>
    <div>
       <HeaderTeam header="รายงานและการสรุปยอด" :img_header="header_image" link_back="team"/>
       <MenuTeamReportAndSummaryList/>
       <SummaryList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/dashboard.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamReportAndSummaryList from '@/components/menuadmin/team/teamreportandsummary/MenuTeamReportAndSummaryList.vue'
import SummaryList from '@/components/menuadmin/team/teamreportandsummary/SummaryList.vue'
export default {
    name:'summary',
    components:{
        HeaderTeam,
        MenuTeamReportAndSummaryList,
        SummaryList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>